import { render } from "./CreateActivityGroup.vue?vue&type=template&id=2de2cb11"
import script from "./CreateActivityGroup.vue?vue&type=script&lang=js"
export * from "./CreateActivityGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__